import { render, staticRenderFns } from "./objectReport.vue?vue&type=template&id=58e80ca6&scoped=true"
import script from "./objectReport.vue?vue&type=script&lang=js"
export * from "./objectReport.vue?vue&type=script&lang=js"
import style0 from "./objectReport.vue?vue&type=style&index=0&id=58e80ca6&prod&lang=css&scoped=true"
import style1 from "./objectReport.vue?vue&type=style&index=1&id=58e80ca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e80ca6",
  null
  
)

export default component.exports